import React from 'react';
import { Form, Header, Modal } from 'semantic-ui-react';

import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';

type Props = {
    correos: readonly string[];
    titulo?: string;
    alCerrar(): void;
};

export const ModalCorreos: React.FunctionComponent<Props> = props => {
    const { alCerrar, correos, titulo = 'Correos electrónicos' } = props;

    return (
        <ModalEnfocable open onClose={alCerrar} closeIcon>
            <Header icon='mail' content={titulo} />

            <Modal.Content>
                <Form>
                    <Form.TextArea
                        label={`${correos.length} correos`}
                        rows='10'
                        autoFocus
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correos.join(', ')}
                    />
                </Form>

                <div style={{ marginTop: '14px' }}>
                    <p>
                        Puede copiar y pegar estos correos directamente en su sistema de correos
                        electrónicos.
                    </p>

                    <p>No se incluyen correos de alumnos restringidos.</p>
                </div>
            </Modal.Content>
        </ModalEnfocable>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Informacion/ModalCorreos.tsx